import React from 'react';
import styled from 'styled-components';

export default ({title}: {title: string}) => {
  return (
    <Container>
      <Title>{title}</Title>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  margin: 1rem 0;
  font-size: 20px;
  font-weight: bold;
`;
